import { useRoute } from 'vue-router';

import { apiManager } from '@/api/api-manager/api-manager';
import { logger } from '@/plugins/logger';
import { useBannersStore } from '@/stores';

import type { TBannerType } from './types';

export interface IGetBannerParams {
  slots: string[];
  categoryUrl?: string;
  withCategory?: boolean;
}

/**
 * Загрузка баннеров
 */
export function useBanner() {
  const bannerStore = useBannersStore();
  const route = useRoute();

  async function loadBanners(params: IGetBannerParams) {
    let { categoryUrl } = params;

    if (params.withCategory !== false) {
      categoryUrl = route.path;
    }

    try {
      const response = await apiManager.$api.getBanners(params.slots, categoryUrl);

      for (const key in response) {
        if (response[key]) {
          bannerStore.setBanner(key, response[key]);
        }
      }
    } catch (err) {
      logger.error(err);
    }
  }

  function getBanner(slotName: string): TBannerType[] {
    return bannerStore.items[slotName] || [];
  }

  function getFirstBanner(slotName: string): TBannerType {
    return getBanner(slotName)[0] || {};
  }

  return {
    // Получение первого баннера
    getFirstBanner,

    // Получение баннеров
    getBanner,

    // Загрузка баннеров
    loadBanners,
  };
}
